import React from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  className?: string;
  icon: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}

const CircledIcon = ({ className, icon, onClick, disabled }: Props) => {
  return (
    <button
      className={twMerge(
        "border-2  border-white rounded-full w-10 h-10 p-2 flex justify-center items-center",
        disabled && "cursor-default",
        disabled && "opacity-60",
        className,
      )}
      onClick={onClick}
      disabled={disabled}
    >
      {icon}
    </button>
  );
};

export default CircledIcon;
